import React from "react";
import TextSketch from "./images/textsketch.svg";
import "./TopLHS.css";

const TopLHS = () => {
  return (
    <div className="uigrid-6 about__top-lhs">
      <div className="about__lhs-inner">
        <div className="about__header-text">
          <h1>Commerce and operations software</h1>
          <div className="about__header-text-sketch">
            <img src={TextSketch} alt="" />
          </div>
        </div>
        <div className="about__header-description">
          <p>
            Awa Digital builds and runs commerce software for restaurants, cloud
            kitchens, and merchants.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TopLHS;
